import { render, staticRenderFns } from "./ForumNavLink.vue?vue&type=template&id=005c14a7&"
import script from "./ForumNavLink.vue?vue&type=script&lang=js&"
export * from "./ForumNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports